import { useEffect } from 'react'

import * as Sentry from '@sentry/nextjs'

import { useOrganizationQuery } from '@/graphql/generated/hooks'

interface UseOrganizationNameIProps {
  /** Skip the query entirely (e.g. the owning feature's flag is off). */
  skip?: boolean
}

interface UseOrganizationNameResultIProps {
  orgName?: string
}

/**
 * Current Org's name for the stale work copy (ENG-32179: banner/modal
 * verbiage uses the Org's name instead of "Team"). Undefined until the
 * query resolves; callers hold off rendering interpolated copy until then.
 */
export const useOrganizationName = ({
  skip,
}: UseOrganizationNameIProps = {}): UseOrganizationNameResultIProps => {
  const { data, error } = useOrganizationQuery({ skip })

  useEffect(() => {
    if (error) {
      // A failed lookup keeps the banner hidden for the session (the query is
      // cache-first and nothing re-runs it), so make the degradation visible.
      Sentry.captureException(error, {
        tags: { action: 'fetch_org_name', feature: 'stale_work' },
      })
    }
  }, [error])

  return { orgName: data?.currentOrganization?.name ?? undefined }
}
